import React from "react";
import { Card, Col, Form, Row } from "react-bootstrap";

const FREQUENCY_OPTIONS = [
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "fortnightly", label: "Fortnightly" },
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "yearly", label: "Yearly" },
];

const MONTH_BASED_FREQUENCIES = new Set(["monthly", "quarterly", "yearly"]);

const getInvoiceDayOfMonth = (dateValue) => {
  if (!dateValue) return "";

  const date = new Date(`${dateValue}T00:00:00`);

  if (Number.isNaN(date.getTime())) return "";

  return date.getDate();
};

const recurringDefaults = (prev) => ({
  recurringFrequency: prev.recurringFrequency || "monthly",
  recurringInterval: prev.recurringInterval || 1,
  recurringDayOfMonth:
    prev.recurringDayOfMonth || getInvoiceDayOfMonth(prev.date) || "",
});

const RecurringInvoiceFields = ({
  formData,
  setFormData,
  labelClassName = "",
  idPrefix = "invoice",
}) => {
  const isMonthBased = MONTH_BASED_FREQUENCIES.has(
    formData.recurringFrequency,
  );

  const handleEnabledChange = (e) => {
    const checked = e.target.checked;

    setFormData((prev) => ({
      ...prev,
      isRecurring: checked,
      ...(checked
        ? recurringDefaults(prev)
        : {
            recurringFrequency: "",
            recurringInterval: 1,
            recurringDayOfMonth: "",
          }),
    }));
  };

  const handleFrequencyChange = (e) => {
    const recurringFrequency = e.target.value;

    setFormData((prev) => ({
      ...prev,
      recurringFrequency,
      recurringDayOfMonth: MONTH_BASED_FREQUENCIES.has(recurringFrequency)
        ? prev.recurringDayOfMonth || getInvoiceDayOfMonth(prev.date) || ""
        : "",
    }));
  };

  const handleIntervalChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      recurringInterval: e.target.value,
    }));
  };

  const handleDayOfMonthChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      recurringDayOfMonth: e.target.value,
    }));
  };

  return (
    <Card className="mt-3 mb-3">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center gap-3 flex-wrap">
          <h5 className="mb-0">Recurring Invoice</h5>
          <Form.Check
            type="switch"
            id={`${idPrefix}-isRecurring`}
            label={formData.isRecurring ? "On" : "Off"}
            checked={Boolean(formData.isRecurring)}
            onChange={handleEnabledChange}
          />
        </div>

        {formData.isRecurring && (
          <Row className="g-3 mt-1">
            <Col md={6}>
              <Form.Group>
                <Form.Label className={labelClassName}>Frequency</Form.Label>
                <Form.Select
                  name="recurringFrequency"
                  value={formData.recurringFrequency}
                  onChange={handleFrequencyChange}
                  required={formData.isRecurring}
                >
                  {FREQUENCY_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className={labelClassName}>Interval</Form.Label>
                <Form.Control
                  type="number"
                  name="recurringInterval"
                  min={1}
                  max={120}
                  step={1}
                  value={formData.recurringInterval}
                  onChange={handleIntervalChange}
                  required={formData.isRecurring}
                />
              </Form.Group>
            </Col>

            {isMonthBased && (
              <Col md={6}>
                <Form.Group>
                  <Form.Label className={labelClassName}>
                    Day of Month
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="recurringDayOfMonth"
                    min={1}
                    max={31}
                    step={1}
                    value={formData.recurringDayOfMonth}
                    onChange={handleDayOfMonthChange}
                    placeholder="Invoice date"
                  />
                </Form.Group>
              </Col>
            )}
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};

export default RecurringInvoiceFields;
